import { render, staticRenderFns } from "./EmployeeBranchAdd.vue?vue&type=template&id=af7bb9e0&"
import script from "./EmployeeBranchAdd.vue?vue&type=script&lang=js&"
export * from "./EmployeeBranchAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports